import { Card, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import {
  callAPI,
  clearRequest,
  Method
} from "../../commonFunctions/CommonFunctions";
import {
  HeaderList,
  IHeaderListActions
} from "../../Components/Header/HeaderList";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { WSIcons } from "../../commonFunctions/iIcons";

export const CustomerRegister: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue } = useForm();
  const password = useWatch({ control, name: "password" });
  const confirmPassword = useWatch({ control, name: "confirmpassword" });
  const passwordsMatch = password === confirmPassword;
  const navigate = useNavigate();
  const params = useParams();
  const id = params?.id;
  const { showMessage } = useSnackbar();

  const handleCancelClick = () => {
    navigate("/customer/list");
  };
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getCustomerById(id: any) {
      try {
        const response: any = await callAPI("customers", Method.GET, null, id);
        if (response && response?.data) {
          setValue("fullName", response.data.fullName);
          setValue("email", response.data.email || "");
          setValue("phoneNumber", response.data.phoneNumber);
          setValue("address", response.data.address || "");
          setValue("confirmpassword", response.data.password || "");
          setValue("password", response.data.password || "");
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
        showMessage("Something went wrong. Please try again.", "error");
      }
    }
    if (id) {
      getCustomerById(id);
    }
  }, [id, setValue]);

  /**
   * Method for Add/Update the data
   * @param data
   */

  const handleData = async (data: any) => {
    try {
      let requestData = {
        fullName: data.fullName,
        email: data.email,
        phoneNumber: data.phoneNumber,
        password: data.password,
        address: data.address
      };

      const newRequest = clearRequest(requestData);

      const endpoint = id ? `customers/${id}` : "customers/register";

      const method = id ? Method.PUT : Method.POST;

      const response: any = await callAPI(endpoint, method, newRequest);

      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );
        response.success === true && navigate("/customer/list");
      }
    } catch (e: any) {
      console.error("Api call failed", e);
      showMessage(e?.error || "Something went wrong", "error");
    }
  };

  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "error",
      icon: <WSIcons.CancelIcon />
    },
    {
      type: "icon",
      text: "Save",
      size: "small",
      buttonType: "submit",
      variant: "outlined",
      color: "success",
      icon: <WSIcons.SaveIcon />
    }
  ];
  return (
    <form onSubmit={handleSubmit(handleData)}>
      <HeaderList title="Manage Customer" type="card" actions={actions} />
      <Card sx={{ padding: 2, borderRadius: 2 }}>
        <Grid
          item
          container
          spacing={1}
          justifyContent={"start"}
          sx={{
            marginTop: 0,
            marginLeft: 0,
            width: "100%",
            backgroundColor: "#7D79C2",
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5
          }}
        >
          <Grid
            alignContent={"center"}
            style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
            item
            sm={4}
            className="ws-data-grid-lightviolet-title"
          >
            <Typography variant="h6" id="tableTitle" sx={{ fontSize: "1rem" }}>
              Customer
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            padding: 3,
            backgroundColor: "#fff",
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            border: "1px solid lightgrey"
            // marginTop: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <WSTextField
                id="fname"
                name="fullName"
                control={control}
                label={"Full Name"}
                rules={{ required: "please enter full name" }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="email"
                name="email"
                control={control}
                label={"Email Address"}
                // rules={{ required: "please enter email address" }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="phoneNumber"
                name="phoneNumber"
                control={control}
                label={"Phone Number"}
                type={TextType.Number}
                rules={{ required: "please enter phone number" }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="password"
                name="password"
                control={control}
                label={"Password"}
                type={TextType.Password}
                // rules={{ required: !id ? "please enter user password" : false }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                control={control}
                maxLength={40}
                id="confirmpassword"
                // {...register("confirmpassword", {
                //   required: !id ? "Please confirm your password" : false,
                //   validate: {
                //     matchesPreviousPassword: (value) =>
                //       passwordsMatch || "Passwords do not match"
                //   }
                // })}
                name="confirmpassword"
                label="Confirm Password *"
                type={TextType.Password}
                // labelType="Normal"
              />
              {/* {!passwordsMatch && confirmPassword && (
                <Typography color="error" sx={{ fontSize: "0.75rem", mt: 1 }}>
                  Passwords do not match
                </Typography>
              )} */}
            </Grid>

            <Grid item xs={12} sm={6}>
              <WSTextField
                id="address"
                name="address"
                control={control}
                label={"Address"}
                // rules={{ required: "please enter customer address" }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </form>
  );
});
